import React, { useState, useEffect } from "react";

const UploadButton = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Update the state when window is resized
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    // Clean up
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // For mobile, return null to not render any special decoration for Upload Graphics tool
  if (isMobile) {
    return null;
  }

  // For desktop, keep the original design with decorative elements
  return (
    <div className="bgd-upload__container">
      <div className="bgd-upload__border" />
      <svg
        className="bgd-upload bgd-upload--top"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 29.3 28.9"
      >
        <path
          className="bgd-upload__path"
          d="M20 1.4L1.4 20M27.9 1.5l-26 26M12 1.5L1.4 12"
        />
      </svg>
      <svg
        className="bgd-upload bgd-upload--bottom"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 31.4 31.9"
      >
        <path
          className="bgd-upload__path"
          d="M29.5 9.9L8.9 30.5M30 17.4l-13.1 13M30 1.4L1.4 30"
        />
      </svg>
    </div>
  );
};

export default UploadButton;
